import { BsQuestionCircleFill } from "react-icons/bs";
import { CardProps } from "../../types";
import styles from "./cards.module.scss";

function BlueCard({ children }: CardProps) {
  return (
    <section className={styles.blueCard}>
      <div className={styles.icon}>
        <BsQuestionCircleFill />
      </div>
      {children}
    </section>
  );
}

export default BlueCard;
